<template>
    <div class="flex_1 margin_horizontal dashboard_box">
        <div class="flex margin_horizontal">
			<AccessRestrictedButton
				class="flex_1"
				style="max-width: 25rem;"
				:button-style="'font-size: 14px !important; font-weight: 500 !important;'"
				:button-class="activeTab === navigationTabs.dashboard.seller ? 'md-primary' : 'md-white'"
				button-name-key="dashSideNav.seller"
				:only-visible-for="[enumDef.traderType.Supplier]"
				@click="changeTab(navigationTabs.dashboard.seller)"
			></AccessRestrictedButton>
			<AccessRestrictedButton
				class="flex_1"
				style="max-width: 25rem;"
				:button-style="'font-size: 14px !important; font-weight: 500 !important; max-width: 25rem;'"
				:button-class="activeTab === navigationTabs.dashboard.buyer ? 'md-primary' : 'md-white'"
				button-name-key="dashSideNav.Investor"
				:only-visible-for="[enumDef.traderType.Investor]"
				@click="changeTab(navigationTabs.dashboard.buyer)"
			></AccessRestrictedButton>
        </div>
        <div class="flex base_margin">
            <dashboardLeft class="dash_left" :activeRate="activeTab"></dashboardLeft>
            <dashboardRight class="dash_right" :activeRate="activeTab"></dashboardRight>
        </div>
    </div>
</template>
<script>
import dashboardLeft from "./dashboardLeft";
import dashboardRight from "./dashboardRight";
import {dashboardInspectionApi} from "@/common/api/dashboardInspectionApi";
import {mapGetters} from "vuex";
import {navigationTabs} from "@/common/navigation/navigationTabs";
import AccessRestrictedButton from "@/components/templates/common/permissions/AccessRestrictedButton";
import {enumDef} from "@/common/enumDefs";

export default {
    components: {
        dashboardLeft,
        dashboardRight,
	    AccessRestrictedButton
    },
    data() {
        return {
        	navigationTabs: navigationTabs,
            activeTab: "",

            // To easily prevent multiple calls for the same data without having the refactor the whole flow
            lastDataQueryParams: {
                years: -1,
                paramsId: ""
            },
			enumDef: enumDef
        };
    },
	created() {
		this.activeTab = this.$store.getters["session/activeTabs"][this.$route.path] || this.defaultTab;
	},
	mounted() {
        this.changeTab(this.activeTab);
    },
    methods: {
        changeTab(type) {
            this.activeTab = type;
            this.$store.dispatch("setActionDashboardFilter", { type: type });
        },
        getInfo() {
            let { type, years, accountId, currency } = this.dashboardFilter;
            let paramsId = type === this.navigationTabs.dashboard.seller ? currency : accountId;
            if (!paramsId || !years || (this.lastDataQueryParams.paramsId === paramsId && this.lastDataQueryParams.years === years)) {
                return;
            }

            this.lastDataQueryParams.paramsId = paramsId;
            this.lastDataQueryParams.years = years;

            dashboardInspectionApi[type]
                .allInfo(paramsId, years)
                .then(res => {
                    this.$store.dispatch("setActionDashboardInfo", res);
                })
                .catch(err => this.toast(err));
        }
    },
    computed: {
        ...mapGetters({ dashboardFilter: "dashboardFilter" }),
	    currentUser() {
		    return this.$sessionStorage.get("localeUser");
	    },
		defaultTab() {
			switch (this.currentUser.companyTraderType) {
				case enumDef.traderType.Supplier:
					return this.navigationTabs.dashboard.seller;
				case enumDef.traderType.Investor:
					return this.navigationTabs.dashboard.buyer;
			}

			return "";
		}
    },
    watch: {
        dashboardFilter() {
            this.getInfo();
        },
        activeTab() {
			this.$store.dispatch("session/setActiveTab", { tabGroup: this.$route.path, activeTab: this.activeTab });
		}
    }
};
</script>
<style lang="scss">
@import "@/assets/scss/dashboard.scss";
</style>